import React from 'react'
import { useSelector } from 'react-redux'
import get from 'lodash/get'

import { Ban } from '@fielded/shared-ui/src/icons'

import { selectAccountSummary, selectIsPaused } from '../reducers/retailer/finances'
import { isNewWalletViewAvailable } from '../../van-shared/utils/utils'
import AccountBlockedModal from '../AccountBlockedModal/AccountBlockedModal'
import WarningNotice from '../WarningNotice/WarningNotice'

const AccountBlockedBanner = ({ showModal, onOpenModal, onCloseModal, config, user }) => {
  const hasNewWalletView = isNewWalletViewAvailable(config, user)

  let isPaused = useSelector(selectIsPaused)
  if (hasNewWalletView) {
    const accountSummary = useSelector(selectAccountSummary)
    isPaused = get(accountSummary, 'isPaused')
  }

  if (!isPaused) {
    return null
  }

  const warningModal = (
    <AccountBlockedModal
      showAccountBlockedModal={showModal}
      onOpenModal={onOpenModal}
      onCloseModal={onCloseModal}
      isPaused={isPaused}
      config={config}
    />
  )

  return (
    <WarningNotice
      type='warning'
      onOpenModal={onOpenModal}
      modal={warningModal}
      icon={<Ban />}
    />
  )
}

export default AccountBlockedBanner
